module.exports = __webpack_public_path__ + "static/media/Nichwagh-Ridge_Articles-of-Incorporation.b5409432.pdf";